import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Plus = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.25 19a.75.75 0 0 0 1.5 0v-6.25H19a.75.75 0 0 0 0-1.5h-6.25V5a.75.75 0 0 0-1.5 0v6.25H5a.75.75 0 0 0 0 1.5h6.25z'
        fill='currentColor'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M11.25 19a.75.75 0 0 0 1.5 0v-6.25H19a.75.75 0 0 0 0-1.5h-6.25V5a.75.75 0 0 0-1.5 0v6.25H5a.75.75 0 0 0 0 1.5h6.25z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
